import type { HfIconSelectorFieldProps } from './hf-icon-selector-field.props';
import OdinController from '../../dynamic-form/odin-controller.component';
import { IconSelectorField } from './icon-selector-field.component';

const HfIconSelectorField = ({
  control,
  name,
  id,
  label,
  value,
  data,
  valueField,
  textField,
  readOnly,
  disabled,
  required,
  onChange,
  className,
}: HfIconSelectorFieldProps) => {
  return (
    <OdinController
      name={name}
      defaultValue={value}
      control={control}
      onChange={onChange}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <IconSelectorField
          id={id}
          label={label}
          value={value}
          data={data}
          textField={textField}
          valueField={valueField}
          readOnly={readOnly}
          disabled={disabled}
          required={required}
          error={error?.message}
          onChange={onChange}
          className={className}
        />
      )}
    />
  );
};

export default HfIconSelectorField;
